// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactForm_container__1vE3R","form":"ContactForm_form__12kIq"};